import { ref, type Ref } from 'vue';
import { safeSetItem, safeGetItem } from 'Utils/safeLocalStorage';
import { useCurrentSite } from 'Composables/useCurrentSite';

export type TCityTerm = {
  id: string;
  name: string;
  slug: string;
  latitude?: number;
  longitude?: number;
};

export function useCityTermLocalStorage() {
  const { currentSiteUpperCase } = useCurrentSite();

  function getCityTermFromLocalStorage(): TCityTerm | null {
    const cityTermStr = safeGetItem(`cityTerm-${currentSiteUpperCase.value}`);

    if (!cityTermStr) {
      return null;
    }

    return JSON.parse(cityTermStr);
  }

  const cityTerm: Ref<TCityTerm | null> = ref(getCityTermFromLocalStorage());

  function saveCityTermToLocalStorage(): void {
    safeSetItem(
      `cityTerm-${currentSiteUpperCase.value}`,
      `${JSON.stringify(cityTerm.value)}`
    );
  }

  return {
    cityTerm,
    saveCityTermToLocalStorage,
    getCityTermFromLocalStorage,
  };
}
